import { Outlet } from "react-router-dom";

export const AuthLayout = () => {
  return (
    <div className="min-h-[100dvh] flex items-start pt-8 md:items-center md:pt-0 justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
};
